import { useLayoutEffect } from "react";

function useLockBodyScroll() {
  useLayoutEffect(
    () => {
      let rootDiv =  document.getElementById('root');
      document.body.style.overflow = "hidden";
      rootDiv.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = "hidden auto";
        rootDiv.style.overflow = "unset";
      };
    },
    []
  );
}

export default useLockBodyScroll;